export default function pluralizeRu(count, forms) {
  const absolute = Math.abs(Number(count)) % 100;
  const lastDigit = absolute % 10;

  let index = 2;
  if (absolute < 11 || absolute > 14) {
    if (lastDigit === 1) index = 0;
    else if (lastDigit >= 2 && lastDigit <= 4) index = 1;
  }

  return forms[index];
}